// 前端元件的类型
export enum SegmentType {
  SubtitleGroup = 'subtitle-group', // 字幕组，目前仅客户端存在
  Text = 'text', // 文本
  Sticker = 'sticker', // 贴纸
  Filter = 'filter', // 滤镜
  Video = 'video', // 视频
  Transition = 'transition', // 转场
  Audio = 'audio', // 音效
  Fragment = 'fragment', // 片段
}

export { Bool } from '@com/enums'

// source_segment_id 关联的业务场景枚举
export enum SourceSegmentIdBizType {
  /** 用户手动添加 */
  Default = '',
  /** ai消除产生的数据 */
  Elimination = 'elimination',
  /** 视频识别产生的数据 */
  Recognized = 'recognized',
  /** 文本翻译成其它语言生成的数据 */
  Translation = 'translation',
  /** 文本转音频的音频元件数据 */
  TTS = 'TTS',
}
